module.exports = __webpack_public_path__ + "img/jimmyjoy_placeholder.039506c0.jpeg";